import { render, staticRenderFns } from "./rightArrow.vue?vue&type=template&id=1ecd123e&scoped=true&"
import script from "./rightArrow.vue?vue&type=script&lang=js&"
export * from "./rightArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd123e",
  null
  
)

export default component.exports